import { render } from "./FooterNr3.vue?vue&type=template&id=7e03a960&scoped=true"
import script from "./FooterNr3.vue?vue&type=script&lang=js"
export * from "./FooterNr3.vue?vue&type=script&lang=js"

import "./FooterNr3.vue?vue&type=style&index=0&id=7e03a960&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e03a960"]])

export default __exports__